import { FETCH_AVAILABILITY, FETCH_MORE_AVAILABILITY, FETCH_MORE_AVAILABILITY_SUCCESS, FETCH_MORE_AVAILABILITY_FAILURE, FETCH_AVAILABILITY_DID_YOU_MEAN, FETCH_AVAILABILITY_SUCCESS, FETCH_AVAILABILITY_FAILURE } from './types'; // Triggers the saga that calls the availability API

export var getAvailability = function getAvailability(url, data) {
  return {
    type: FETCH_AVAILABILITY,
    url: url,
    data: data
  };
}; // Fired when the availability API returns a 'Did You Mean' response

export var availabilityDidYouMean = function availabilityDidYouMean(suggestions) {
  return {
    type: FETCH_AVAILABILITY_DID_YOU_MEAN,
    payload: suggestions
  };
}; // Fired when the availability API returns a list of stores with stock info

export var availabilityLoaded = function availabilityLoaded(payload) {
  return {
    type: FETCH_AVAILABILITY_SUCCESS,
    payload: payload
  };
}; // Fired when the availability API fails

export var availabilityFailed = function availabilityFailed(error) {
  return {
    type: FETCH_AVAILABILITY_FAILURE,
    error: error
  };
}; // Triggers the saga that calls the Stock Finder API

export var getMoreAvailability = function getMoreAvailability(url, data) {
  return {
    type: FETCH_MORE_AVAILABILITY,
    url: url,
    data: data
  };
}; // Fired when the Stock Finder API returns a store

export var moreAvailabilityLoaded = function moreAvailabilityLoaded(payload) {
  return {
    type: FETCH_MORE_AVAILABILITY_SUCCESS,
    payload: payload
  };
}; // Fired when the Stock Finder API doesn't return a store

export var moreAvailabilityFailed = function moreAvailabilityFailed(error) {
  return {
    type: FETCH_MORE_AVAILABILITY_FAILURE,
    error: error
  };
};